import { useEffect } from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { AppHeader } from "./components/AppHeader";
import { CalendarPage } from "./pages/CalendarPage";
import { DayPage } from "./pages/DayPage";
import { SettingsPage } from "./pages/SettingsPage";
import { registerLedgerTools } from "./webmcp";

function AppRoutes() {
  useEffect(() => registerLedgerTools(), []);
  return (
    <div className="app-shell">
      <AppHeader />
      <Routes>
        <Route path="/" element={<CalendarPage />} />
        <Route path="/day/:date" element={<DayPage />} />
        <Route path="/settings" element={<SettingsPage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </div>
  );
}

export default function App() {
  return <BrowserRouter><AppRoutes /></BrowserRouter>;
}
